<script>


import FileInput from "@/components/form/FileInput.vue";

export default {
    components: {FileInput},
    data() {
        return {
            loading: false,
            errors: [],
            termsAccepted: false,
            termsError: null,
            success: false,
            controller: {
                load: null
            },
            file: null,
            errorMessage: null,
            successMessage: null,
            downloadingSampleFile: false
        }
    },

    methods: {
        submit() {
            if (!this.termsAccepted) {
                this.termsError = this.$t('messages.agreement_required');
                return;
            }
            this.loading = true;
            this.errorMessage = null;
            this.successMessage = null;
            this.errors = [];

            let data = new FormData();
            data.append('file', this.file);

            axios.post('/token-transactions/import', data).then(response => {
                this.$emit('sent');
                this.successMessage = this.$t('token_transactions.messages.tokens_queued');
                this.file = null;
            }).catch(error => {
                if (error.response && error.response.data && error.response.data.errors) {
                    this.errors = error.response.data.errors;
                }
                if (error.response && error.response.data && error.response.data.error) {
                    this.errorMessage = error.response.data.error;
                }
            }).finally(() => {
                this.loading = false;
                this.file = null;
            })
        },
        downloadSampleFile() {
            this.downloadingSampleFile = true;
            axios({
                url: '/token-transactions/sample-import-file',
                method: 'GET',
                responseType: 'blob',
            }).then((response) => {
                saveAs(response.data, 'transactions.csv');
            }).finally(() => {
                this.downloadingSampleFile = false;
            });
        },
        close() {
            this.$emit('close');
        },
    }
};
</script>

<template>
    <section>
        <div class="modal is-active">
            <div class="modal-background"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">{{ $t('token_transactions.labels.send_tokens') }}</p>
                    <button class="delete" aria-label="close" @click="close"></button>
                </header>
                <div class="modal-card-body">

                    <b-message v-if="errorMessage" type="is-danger">
                        {{ errorMessage}}
                    </b-message>
                    <b-message v-if="successMessage" type="is-success">
                        {{ successMessage}}
                    </b-message>

                    <section class="is-flex is-flex-direction-column is-align-items-center block">
                        <b-field>
                            <FileInput v-model="file"/>
                        </b-field>
                    </section>
                    <section class="block errors-block" v-if="errors.length">
                        <b-message v-for="error in errors" type="is-danger">
                            <p v-for="messages in error.errors">
                                {{ $t('data.row') }} {{ error.row }}: {{ messages }}
                            </p>
                        </b-message>
                    </section>
                    <div class="block">
                        <div class="field">
                            <label class="checkbox">
                                <input type="checkbox" v-model="termsAccepted"/>
                                {{ $t('token_transactions.agreements.token_charge_agreement') }}
                            </label>
                            <p v-if="termsError" class="help is-danger">
                                {{ termsError }}
                            </p>
                        </div>
                    </div>
                </div>

                <footer class="modal-card-foot">
                    <div class="buttons">
                        <b-button @click="submit()"
                                :disabled="loading || !termsAccepted || !file"
                                :loading="loading"
                                type="is-success">
                            {{ $t('actions.send') }}
                        </b-button>

                        <b-button type="is-info"
                                  :loading="downloadingSampleFile"
                                  :disabled="downloadingSampleFile"
                                  icon-left="download"
                                  @click.prevent="downloadSampleFile()">
                            {{ $t('actions.download_sample_file') }}
                        </b-button>

                        <b-button class="button" @click="close">
                            {{ $t('actions.cancel') }}
                        </b-button>

                    </div>
                </footer>
            </div>
        </div>
    </section>
</template>
<style scoped>
.modal-card {
    min-height: 500px;
}
.errors-block {
    max-height: 240px;
    overflow: auto;
}
</style>
